/**
 * Returns the filtered location set if a make filter is active,
 */
const getDisplayLocations = (locationsData) => {
	const hasFilters = locationsData.hasActiveFilters?.() ?? false;
	return hasFilters
		? locationsData.getFilteredLocations() || []
		: locationsData.getLocations() || [];
};

export default getDisplayLocations;
